<template style="height: 100%;">
    <div style="height: 100%" >

<!--导入记录-->
            <div  style="display: flex;justify-content: space-between;margin-right: 20px;height: 40px;align-items: center">
                <div style="display: flex;margin-left: 20px">
                    <div>
                        <input type="file" name="files" value="" id="uploadfile1"
                               class="upload-input uploadfile1" @change="uploadFile1"  >
                        <el-button  type="text" icon="el-icon-upload">打卡数据导入</el-button>
                    </div>
                    <div>
                        <input type="file" name="files" value="" id="uploadfile2"
                               class="upload-input uploadfile2" @change="uploadFile2" >
                        <el-button icon="el-icon-upload" type="text">排班数据导入</el-button>
                    </div>
                    <div>

                        <el-button  type="text" @click="attendresult">生成考勤</el-button>
                    </div>
                </div>
                <div style="display: flex">
                    <el-date-picker
                            size="mini"
                            style="width: 160px;"
                            value-format="yyyy-MM"
                            v-model="attendenceDate"
                            type="month"
                            placeholder="选择月">
                    </el-date-picker>
                    <el-select @change="kqdataChange" style="width: 30%;" size="mini" v-model="kqdata" slot="prepend" placeholder="请选择">
                        <el-option v-for="val in kaoqinList" :key="val.i_id" :label='val.vc_tcname' :value="val.vc_tcname"></el-option>
                    </el-select>
                <el-input
                        @input="StatsSearch"
                        size="mini"
                        class="input"
                        placeholder="请输入搜索内容"
                        v-model="StatsSearchdata"
                        clearable>
                </el-input>
                <el-button style="height: 28px" size="mini"  icon="el-icon-search"></el-button>
                </div>
            </div>
            <el-table
                    class="el-table-width"
                    ref="deliverlight"
                    :height="tableHeight"
                    highlight-current-row
                    :data="tableData"
                    border>
                <el-table-column
                        prop="fileName"
                        label="文件名"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="type"
                        label="类型"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==1">打卡</span>
                        <span v-if="scope.row.type==2">排班</span>
                        <span v-if="scope.row.type==3">考勤结果</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="result"
                        label="处理结果"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.result==1">成功</span>
                        <span v-if="scope.row.result==0">失败</span>
<!--                        <span v-if="scope.row.type==2">审核完成</span>-->
                    </template>
                </el-table-column>
                <el-table-column
                        prop="forMonth"
                        label="考勤月份"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="uploaderName"
                        label="导入者"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="uploadTime"
                    label="导入时间"
                    show-overflow-tooltip>
            </el-table-column>
                <el-table-column
                        label="操作"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.type==3"  type="text">审核通过</el-button>
                        <el-button v-if="scope.row.type==1"  type="text" @click="addPunch(scope.row)">补打卡</el-button>
                        <el-button v-if="scope.row.type==2"  type="text" @click="addSche(scope.row)">补排班</el-button>
                        <el-button v-if="scope.row.result==2"  type="text" @click="addSche(scope.row)">补排班</el-button>

                        <el-button  type="text" >查看</el-button>

<!--                        <span v-if="scope.row.type==3">审核通过</span>-->
                    </template>
                </el-table-column>
            </el-table>
            <!--        分页器-->
            <div class="block">
                <div class="pages">
                    <div class="choosepage flexother mrt20 fl">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="this.currentPage"
                                :page-sizes="[10, 20, 30, 40]"
                                :page-size="this.pageSize"
                                layout="total,sizes"
                                :total="this.total"
                        >
                        </el-pagination>
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="this.currentPage"
                                :page-size="this.pageSize"
                                layout="prev, pager, next, jumper"
                                :total="this.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        <!--排班导入弹框-->
        <el-dialog
                style="display: flex;justify-content: center;align-items: center"
                width="39.429rem"
                top="2.143rem"
                height="300"
                title="排班导入"
                :visible.sync="addSchedialog"
                v-if="addSchedialog"
        >
            <sche-dialog :djmark="djmark" :kaoqini_id="kaoqini_id" @saveSche="saveSche" style="display: flex;justify-content: center"  @close="close"> </sche-dialog>
        </el-dialog>

        <!--打卡导入弹框-->
        <el-dialog
                style="display: flex;justify-content: center;align-items: center"
                width="39.429rem"
                top="2.143rem"
                height="300"
                title="打卡导入"
                :visible.sync="addPunchdialog"
                v-if="addPunchdialog"
        >
            <punch-import :djmark="djmark" class="displayflex" @savePunch="savePunch"   @close="close"> </punch-import>
        </el-dialog>
        <!--批量导入弹框-->
<!--        <el-dialog-->
<!--                style="display: flex;justify-content: center;align-items: center"-->
<!--                width="39.429rem"-->
<!--                top="2.143rem"-->
<!--                height="300"-->
<!--                title="批量导入"-->
<!--                :visible.sync="moreuploadFile"-->
<!--                v-if="moreuploadFile"-->
<!--        >-->
<!--            <file-dialog :djmark="djmark" class="displayflex"  @close="close"> </file-dialog>-->
<!--        </el-dialog>-->
        </div>
</template>

<script>
    import * as API from "./api"
    import PunchImport from "./component/PunchImport";
    import ScheDialog from "./component/ScheDialog";
    // import FileDialog from "./component/FileDialog";

    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "workManage",
        components:{
            // FileDialog,
            PunchImport,
            ScheDialog
        },
        data(){
            return{
                attendenceDate:'',
                inputType:'text',
                moreuploadFile:false,
                uploadType:0,
                kqdata:'',
                addSchedialog:false,
                addPunchdialog:false,
                filenewname:'',
                tableData: [],//列表数据
                currentPage:1,//页
                pageSize:15,//条
                total:0,//总数
                baseerp:'',//公共样式
                StatsSearchdata:'',//搜索记录内容
                tableHeight:0,
                djmark:'',//考勤方案
                kaoqinList:[],
                kaoqini_id:0,
                fileId:0,
                uploadtype:0,
                departmentId:0
            }
        },
        watch:{
            treedata:{
                handler(){
                    if (this.treedata){
                    }
                },
                immediate:true,
                deep:true
            },



        },
        mounted(){

            this.baseerp=baseerp
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
            let month=(new Date().getMonth()+1)>10?new Date().getMonth()+1:'0'+(new Date().getMonth()+1)

            this.attendenceDate=JSON.stringify(new Date().getFullYear())+'-'+month

            //获取导入记录列表
            this.records()
            // this.getJqDetailList()
            this.getKqList()
            // console.log(this.kaoqinList)
            // this.kqdata=this.kaoqinList[0].vc_tcname
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            //文件上传
            async uploadFile1(value) {

                let that = this;
                let i = 0;
                let $files = value.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                // if(($files && result==false) || ($files &&result==undefined)){
                //     that.$message.error('请上传格式正确的文件');
                //     return;
                // };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        "style": "attendence",
                        "files": $files,
                        "vc_app": "attendence",
                        "i_appid": 0,
                        "vc_lruname":  sessionStorage.getItem("userid"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.uploadFile(param);
                    if (res.code == 1) {
                        // console.log(1)/
                        this.filenewname=res.data[0].filenewname
                        this.upload1()
                        // console.log(res)
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            async uploadFile2(value) {
                // console.log(this.uploadtype)
// return
                // console.log(value)
                // return
                let that = this;
                let i = 0;
                let $files = value.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                // if(($files && result==false) || ($files &&result==undefined)){
                //     that.$message.error('请上传格式正确的文件');
                //     return;
                // };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "attendence",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "attendence",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("userid"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.uploadFile(param);
                    if (res.code == 1) {
                        // console.log(1)/
                        this.filenewname=res.data[0].filenewname
                        this.upload2()
                        // console.log(res)
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            //文件上传
            async upload1(){
                // console.log(2)
                // return
                var loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                let param={
                    newName:this.filenewname,
                    userId:sessionStorage.getItem("userid"),
                    userName:sessionStorage.getItem("lruname"),
                    type:1,
                    date:this.attendenceDate,
                    djmark:this.djmark
                }
                // console.log(param.type)

                let res=await API.upload(param)
                if(res.code==1){
                    loading.close()
                    this.records()
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    // this.tableData.bcdetail=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            //文件上传
            async upload2(){
                // console.log(2)
                // return
                var loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                let param={
                    newName:this.filenewname,
                    userId:sessionStorage.getItem("userid"),
                    userName:sessionStorage.getItem("lruname"),
                    type:2,
                    date:this.attendenceDate,
                    djmark:this.djmark
                }
                // console.log(param.type)

                let res=await API.upload(param)
                if(res.code==1){
                    loading.close()
                    this.records()
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    // this.tableData.bcdetail=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            // uploadFile1(val){
            //     this.uploadtype=1
            //     this.uploadFile(val)
            //     // console.log(1)
            // },
            // uploadFile2(val){
            //     this.uploadFile(val)
            //
            //     this.uploadtype=2
            //     // console.log(2)
            //
            // },
            //补打卡
            addPunch(val){
                // console.log(this.tableData)
                this.fileId=val.id
                this.addPunchdialog=true
            },
            //补排班
            addSche(val){
                this.fileId=val.id
                this.addSchedialog=true
            },
            //考勤下拉框
            kqdataChange(val){
                // console.log(val)
                this.kqdata=val
                let kqdjmark=this.kaoqinList.filter(item=>{
                    return item.vc_tcname==val
                })
                this.djmark=kqdjmark[0].vc_djmark
                this.kaoqini_id=kqdjmark[0].i_id
                // console.log(kqdjmark)
            },
            //树数据
            getValue(val){
                this.treedata=val
            },
            focusupload(){
                // console.log(999)
            },
            //高度
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.deliverlight.$el.clientTop - 264;
            },
            beforeDestroy() {
                window.removeEventListener('resize',this.heightAuto)
            },
            //分页
            handleSizeChange(val) {
                this.pageSize = val;    //动态改变
                this.records()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.records()

            },
            //关闭弹框
            close(){
                this.addPunchdialog=false
                this.addSchedialog=false
                this.moreuploadFile=false

            },
            //搜索
            StatsSearch(){
                this.records()
                this.currentPage=1
            },

            //保存排班
            async saveSche(data){
                // console.log(data)
                return
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                let param={
                    bcId:data.bcId,
                    bcName:data.bcName,
                    bcNote:data.bcNote,
                    creator:sessionStorage.getItem("lruname"),
                    djmark:this.djmark,
                    dkNum:data.dkNum,
                    name:data.name,
                    scheduleDate:data.scheduleDate,
                    theoryHour:data.theoryHour,
                    userId:sessionStorage.getItem("userid"),
                    whichHalf:data.whichHalf,
                    workEndTime:data.workEndTime,
                    workStartTime:data.workStartTime,
                    fileId:this.fileId,
                    type:2,
                    dkRange:data.dkRange
                }
                let res=await API.save(param)
                if(res.code==1){
                    this.addSchedialog=false
                    // console.log(res,11)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },

            //考勤方案接口
            async getKqList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,

                };
                let res = await API.getKqList(param);
                if (res.code == 1) {
                    // console.log('zxc')
                    // this.ceshiData[0].children=res.data;
                    this.kaoqinList=res.data
                    // console.log(res.data)
                    this.kqdata=res.data[0].vc_tcname
                    // console.log(this.kqdata)
                    let kqdjmark=this.kaoqinList.filter(item=>{
                        return item.vc_tcname==this.kqdata
                    })
                    this.kaoqini_id=kqdjmark[0].i_id
                    this.djmark=kqdjmark[0].vc_djmark
                    // this.tableData.djmark=this.djmark
                    // console.log(kqdjmark)

                    // console.log(res.data,'-00000');
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //生成考勤
            async attendresult() {
                // console.log(this.kaoqini_id)
                // return
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    date:this.attendenceDate,
                    departId:0,
                    creatorId:sessionStorage.getItem("userid"),
                    creatorName:sessionStorage.getItem("lruname")

                };
                let res = await API.result(param);
                if (res.code == 1) {
                    this.records()
                    this.$message({
                        message:res.message,
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //打卡导入保存
            async savePunch(data) {
                // console.log(data)
                // return
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.i_kqtcid)
                let params = {
                    name:data.name,
                    djmark:this.djmark,
                    department:data.department,
                    clockInTime:data.clockInTime,
                    userId:sessionStorage.getItem("userid"),
                    type:1,
                    fileId:this.fileId,

                }
                let res = await API.save(params);
                if (res.code == 1) {
                    this.addPunchdialog=false
                    this.$message({
                        message:res.message,
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //分页获取导入记录列表
            async records() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    pageSize:this.pageSize,
                    currentPage: this.currentPage,
                    keyName:this.StatsSearchdata,
                    type:0
                }
                let res = await API.records(params);
                if (res.code == 1) {
                    this.tableData=res.data.list
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

        }
    }
</script>

<style lang="scss" scoped>
    .uploadfile1{
        position: absolute;
        opacity: 0;
        top: 6px;
        left: 27px;
        width: 100px;
        height: 80px;
    }
    .uploadfile2
    {
        top: 6px;
        left: 135px;
        position: absolute;
        opacity: 0;
        width: 110px;
        height: 80px;
    }
    .displayflex{
        /*min-width: 39.286rem;*/
        width: 100%;
        /*height: 2.857rem;*/
        display: flex;
        /*justify-content: space-between;*/
        flex-direction: column;
        align-items: center;
        /*margin: 0 0.857rem;*/
    }
    /deep/{
        .el-table-width{
            min-width: 960px;
        }
        .el-table--enable-row-transition{
            min-width: 64.286rem !important;
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        min-width:41.571rem;
        width:90%
    }
    .left{
        width: 17.857rem;
    }
</style>